import { useState } from 'react';

import { IconButton } from '@/components/button';
import { Input } from '@/components/form/input';

type TabEditFormProps = {
  onSave: (name: string) => void;
  onCancel: () => void;
  initialValue?: string;
  placeholder?: string;
};

export const TabEditForm = ({
  onSave,
  onCancel,
  initialValue = '',
  placeholder = 'Tab name...',
}: TabEditFormProps) => {
  const [value, setValue] = useState(initialValue);

  const handleSave = () => {
    if (value.trim()) {
      onSave(value.trim());
    } else {
      onCancel();
    }
  };

  return (
    <>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
          }
          if (e.key === 'Escape') {
            onCancel();
          }
        }}
        autoSelect
        required
      />
      <IconButton type="gray" icon="Check" title="Save" onClick={handleSave} />
      <IconButton type="gray" icon="X" title="Cancel" onClick={onCancel} />
    </>
  );
};
